export default __webpack_public_path__ + "static/media/internet.efc29c54.svg";